// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".activeTab[data-v-723846e2]{background:linear-gradient(166deg,#fae439 -6.27%,#ffba08 106.87%),#797ca1;color:#232323!important}.newsTextShadow[data-v-723846e2]{text-shadow:0 4px 4px rgba(0,0,0,.25)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
